import {
  getPassingCompletionPercentage,
  getPassingAverage,
  getRushingAverage,
  getReceivingAverage,
  getPuntingAverage
} from "./statsHelpers";

// if the relevant field was not changed, the result will be false and therefore should not be returned
// the false value comes from the failed conditional, fieldName === "x"
// check for false explicitly and not all falsy values because null and 0 are allowed
const isNotFalse = (val) => val !== false;

const midStatsChanges = (fieldName, stats) => {
  const passingCompletionPercentage =
    (fieldName === "passingCompletions" || fieldName === "passingAttempts") &&
    getPassingCompletionPercentage(stats);

  const passingAverage =
    (fieldName === "passingYards" || fieldName === "passingAttempts") &&
    getPassingAverage(stats);

  const rushingAverage =
    (fieldName === "rushingYards" || fieldName === "rushingAttempts") &&
    getRushingAverage(stats);

  const receivingAverage =
    (fieldName === "receivingYards" || fieldName === "receptions") &&
    getReceivingAverage(stats);

  const puntingAverage =
    (fieldName === "punts" || fieldName === "puntingYards") &&
    getPuntingAverage(stats);

  return {
    ...(isNotFalse(passingCompletionPercentage) && {
      passingCompletionPercentage
    }),
    ...(isNotFalse(passingAverage) && { passingAverage }),
    ...(isNotFalse(rushingAverage) && { rushingAverage }),
    ...(isNotFalse(receivingAverage) && { receivingAverage }),
    ...(isNotFalse(puntingAverage) && { puntingAverage })
  };
};

export { midStatsChanges };
